export enum SystemControlMode {
  Off = 'Off',
  Auto = 'Auto',
  Manual = 'Manual',
  Unknown = 'Unknown',
  NotSupported = 'NotSupported'
}
